const IcAppointMentSummaryWaiting = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='32' height='33' viewBox='0 0 32 33' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.66669 7.4334C6.07759 7.4334 5.60002 7.91096 5.60002 8.50006V27.1667C5.60002 27.7558 6.07759 28.2334 6.66669 28.2334H25.3334C25.9225 28.2334 26.4 27.7558 26.4 27.1667V8.50006C26.4 7.91096 25.9225 7.4334 25.3334 7.4334H6.66669ZM3.40002 8.50006C3.40002 6.14365 4.31028 5.2334 6.66669 5.2334H25.3334C27.6898 5.2334 28.6 6.14365 28.6 8.50006V27.1667C28.6 29.5231 27.6898 30.4334 25.3334 30.4334H6.66669C4.31028 30.4334 3.40002 29.5231 3.40002 27.1667V8.50006Z'
        fill='#2D6772'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21.5 2.5C22.3284 2.5 23 3.08763 23 3.8125V8.1875C23 8.91237 22.3284 9.5 21.5 9.5C20.6716 9.5 20 8.91237 20 8.1875V3.8125C20 3.08763 20.6716 2.5 21.5 2.5Z'
        fill='#2D6772'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.5 2.5C11.3284 2.5 12 3.08763 12 3.8125V8.1875C12 8.91237 11.3284 9.5 10.5 9.5C9.67157 9.5 9 8.91237 9 8.1875V3.8125C9 3.08763 9.67157 2.5 10.5 2.5Z'
        fill='#2D6772'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4 13.5C4 12.9477 4.63207 12.5 5.41176 12.5H26.5882C27.3679 12.5 28 12.9477 28 13.5C28 14.0523 27.3679 14.5 26.5882 14.5H5.41176C4.63207 14.5 4 14.0523 4 13.5Z'
        fill='#2D6772'
      />
    </svg>
  );
};

export default IcAppointMentSummaryWaiting;
